

























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'

import { GlobalStats } from '../../../shared/models/global-stats.model'
import { GlobalStatsHistory } from '../../../shared/models/global-stats-history'
import { getGlobalStatsHistory } from '../shared/instance-http'

import * as bytes from 'bytes'
import dayjs from 'dayjs'
import TrendChart from 'vue-trend-chart'
import InstanceStatsHistory from '@/components/InstanceStatsHistory.vue'

@Component({
  components: {
    InstanceStatsHistory,
    TrendChart
  },
  filters: {
    asDirection: (value: string) => String(value).startsWith('-')
      ? '▼' + value.replace('-', '')
      : '▲' + value,
    formatNumber: (value: string) => value.toLocaleString(),
    formatBytes: (value: string) => bytes.format(parseInt(value, 10)),
    formatDate: (value: string) => dayjs(value).format('dddd, MMMM D YYYY'),
    formatDateShort: (value: string) => dayjs(value).format('MMM D, YYYY')
  }
})
export default class InstanceStats extends Vue {
  beforeDate = ''
  stats: GlobalStats = null
  statsHistory: GlobalStatsHistory = null
  statsWeek: {
    [key: string]: {
      data: {
        key: string // needed duplicate for onMouseMove/currentInfo
        date: string
        value: string
      }
    }
  } = null
  currentInfo: {
    key: string
    date: string
    value: string
  } = null
  cards = [
    { key: 'totalInstances', label: 'Instances' },
    { key: 'totalUsers', label: 'Users' },
    { key: 'totalVideoComments', label: 'Comments' },
    { key: 'totalVideos', label: 'Videos' },
    { key: 'totalVideoViews', label: 'Views' },
    { key: 'totalVideoFilesSize', label: 'Of video files' }
  ]

  @Watch('$route') onRouteChanged(to, from) {
    const newBeforeDate = to.query?.beforeDate as string
    if (newBeforeDate !== this.beforeDate) this.getStats(newBeforeDate)
    this.beforeDate = newBeforeDate
  }

  mounted () {
    this.getStats(this.$route?.query?.beforeDate as string)
  }

  onMouseMove (params: any) {
    if (!params) {
      this.currentInfo = null
      return
    }

    this.currentInfo = {
      key: params.data[0]?.key,
      date: params.data[0]?.date,
      value: params.data[0]?.value
    }
  }

  async getStats (beforeDate?: string) {
    this.beforeDate = beforeDate || this.beforeDate
    const statsHistory = await getGlobalStatsHistory({ beforeDate })

    if (statsHistory.data.length > 0) {
      this.stats = statsHistory?.data[0]?.stats
      this.statsHistory = statsHistory
      this.cards.forEach(card => {
        this.statsWeek = Object.assign(this.statsWeek || {}, { [card.key]: this.setStatsForWeek(card.key) })
      })
    } else {
      this.statsHistory = this.stats = this.statsWeek = null
    }
  }

  private setStatsForWeek (key: string) {
    // compute difference with the previous day for today + 7 previous days
    const last9data = this.statsHistory?.data?.slice(0, 10)
    const last8data = []
    for (let i = 0; i < last9data.length - 1; i++) {
      const next = last9data[ (i + 1) % last9data.length ]
      last8data.push({
        date: last9data[i].date,
        value: last9data[i].stats[key] - next.stats[key]
      })
    }

    return {
      smooth: true,
      fill: true,
      showPoints: true,
      data: last8data.reverse().map(e => ({
        key,
        date: e.date,
        value: e.value
      }))
    }
  }
}
